import { bigintReplacer } from "@/shared/json";

import { resolveCategoryLabel } from "../../resolveCategoryLabel";

/**
 * Convert a log cell value to a display string.
 *
 * When {@link categories} is provided (for categorical / enum columns),
 * numeric values are formatted as `"3 (Configured)"` using the category
 * list as an index→label mapping.  String values are returned as-is
 * (they are already the label).
 */
export function toDisplayable(value: unknown, categories?: string[]): string {
  switch (typeof value) {
    case "undefined":
      return "Not set";
    case "string":
      // If the value is already a string category name, return it as-is.
      return value;
    case "number": {
      if (categories) {
        return resolveCategoryLabel(value, categories) ?? value.toString();
      }
      return value.toString();
    }
    case "bigint":
      return value.toString();
    case "boolean":
      return value.toString();
    case "object":
      if (value === null) {
        return "null";
      }
      return JSON.stringify(value, bigintReplacer);
    default:
      return String(value);
  }
}
